import {
  LOAD_CLOCK_TASK_BY_ID,
  LOAD_PROJECT_BY_ID,
  GET_PROJECTS_BY_USER_ID,
  START_CLOCK_BY_TASK_ID,
  STOP_CLOCK_BY_TASK_ID,
} from '../../actions/taskClock';

import {
  path,
  find,
  findIndex,
  propEq,
} from 'ramda';

export default function taskClock(state = {}, action) {
  switch (action.type) {
    case LOAD_CLOCK_TASK_BY_ID:
      return Object.assign({}, state, action.payload);
    case LOAD_PROJECT_BY_ID:
      return Object.assign({}, state, action.payload);
    case GET_PROJECTS_BY_USER_ID:
      return Object.assign({}, state, action.payload);
    case START_CLOCK_BY_TASK_ID: {
        const itemId = path(['clockTask','item_id'], action.payload);
        const taskId = path(['clockTask','task_id'], action.payload);
        const itemIndex = findIndex(propEq('id', itemId))(state.list);
        const taskIndex = findIndex(propEq('id', taskId))(state.list[itemIndex].tasks);
        if(!state.list[itemIndex].tasks[taskIndex].clock) {
          state.list[itemIndex].tasks[taskIndex].clock = {};
        }
        state.list[itemIndex].tasks[taskIndex].clock.duration = path(['clockTask','duration'], action.payload);
        state.list[itemIndex].tasks[taskIndex].clock.started = path(['clockTask','started'], action.payload);
        state.list[itemIndex].tasks[taskIndex].clock.stopped = null;
        return Object.assign({}, state, action.payload);
      }
    case STOP_CLOCK_BY_TASK_ID: {
        const itemId = path(['clockTask','item_id'], action.payload);
        const taskId = path(['clockTask','task_id'], action.payload);
        const itemIndex = findIndex(propEq('id', itemId))(state.list);
        const taskIndex = findIndex(propEq('id', taskId))(state.list[itemIndex].tasks);
        if(!state.list[itemIndex].tasks[taskIndex].clock) {
          state.list[itemIndex].tasks[taskIndex].clock = {};
        }
        state.list[itemIndex].tasks[taskIndex].clock.duration = path(['clockTask','duration'], action.payload);
        state.list[itemIndex].tasks[taskIndex].clock.stopped = path(['clockTask','stopped'], action.payload);
        return Object.assign({}, state, action.payload);
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/taskClock/index.js